import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import SwipeableViews from "react-swipeable-views";

// material-ui components
import { makeStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Grid from "@material-ui/core/Grid";

// core components
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import { GridProps } from "@material-ui/core/Grid";

import styles from "assets/jss/elite-feats-cms/components/navPillsStyle";

const useStyles = makeStyles(styles);

interface NavPillDefTab {
  tabButton?: string;
  tabIcon?: React.ComponentType<{ className?: string }>;
  tabContent?: React.ReactNode;
}

interface NavPillDefProps {
  active?: number;
  tabs: NavPillDefTab[];
  color?: "primary" | "warning" | "danger" | "success" | "info" | "rose";
  direction?: string;
  horizontal?: { tabsGrid?: Partial<GridProps>; contentGrid?: Partial<GridProps> };
  alignCenter?: boolean;
}

export default function NavPills(props: NavPillDefProps): React.ReactElement {
  const [active, setActive] = React.useState(props.active);
  const handleChange = (event: React.ChangeEvent<{}>, active: number) => {
    setActive(active);
  };
  const handleChangeIndex = (index: number) => {
    setActive(index);
  };
  const classes = useStyles();
  const { tabs, direction, color, horizontal, alignCenter } = props;
  const flexContainerClasses = classNames({
    [classes.flexContainer]: true,
    [classes.horizontalDisplay]: horizontal !== undefined,
  });
  const viewRef = React.useRef<SwipeableViews>(null);
  React.useEffect(() => {
    setTimeout(() => {
      viewRef.current!.getChildContext().swipeableViews.slideUpdateHeight();
    }, 2000);
  }, []);
  const tabButtons = (
    <Tabs
      classes={{
        root: classes.root,
        fixed: classes.fixed,
        flexContainer: flexContainerClasses,
        indicator: classes.displayNone,
      }}
      value={active}
      onChange={handleChange}
      centered={alignCenter}
    >
      {tabs.map((prop, key) => {
        const icon: { icon?: React.ReactElement } = {};
        if (prop.tabIcon !== undefined) {
          icon["icon"] = <prop.tabIcon className={classes.tabIcon} />;
        }
        const pillsClasses = classNames({
          [classes.pills]: true,
          [classes.horizontalPills]: horizontal !== undefined,
          [classes.pillsWithIcons]: prop.tabIcon !== undefined,
        });
        return (
          <Tab
            label={prop.tabButton}
            key={key}
            {...icon}
            classes={{
              root: pillsClasses,
              selected: classes[color as string],
            }}
          />
        );
      })}
    </Tabs>
  );
  const tabContent = (
    <div className={classes.contentWrapper}>
      <SwipeableViews
        ref={viewRef}
        axis={direction === "rtl" ? "x-reverse" : "x"}
        index={active}
        onChangeIndex={handleChangeIndex}
        style={{ overflowY: "hidden" }}
        animateHeight
      >
        {tabs.map((prop, key) => {
          return (
            <div
              className={classes.tabContent}
              key={key}
              style={{ paddingLeft: 2, paddingRight: 2, marginTop: 20 }}
            >
              {prop.tabContent}
            </div>
          );
        })}
      </SwipeableViews>
    </div>
  );
  return horizontal !== undefined ? (
    <Grid container>
      <Grid item {...horizontal.tabsGrid}>
        {tabButtons}
      </Grid>
      <Grid item {...horizontal.contentGrid}>
        {tabContent}
      </Grid>
    </Grid>
  ) : (
    <div>
      {tabButtons}
      {tabContent}
    </div>
  );
}

NavPills.defaultProps = {
  active: 0,
  color: "primary",
};

